var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shortcut-container" }, [
    _c(
      "div",
      {
        staticClass: "circle-shortcut",
        class: {
          activated: _vm.oneToggle,
          deactivated: !_vm.oneToggle,
          disabled: _vm.checkLayerDisable(0),
        },
        on: {
          click: function ($event) {
            !_vm.checkLayerDisable(0) &&
              _vm.toggleBtn(0, !_vm.oneToggle) &&
              (_vm.oneToggle = !_vm.oneToggle)
          },
        },
      },
      [_vm._v(_vm._s(_vm.btnLabels[0]))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "circle-shortcut",
        class: {
          activated: _vm.twoToggle,
          deactivated: !_vm.twoToggle,
          disabled: _vm.checkLayerDisable(1),
        },
        on: {
          click: function ($event) {
            !_vm.checkLayerDisable(1) &&
              _vm.toggleBtn(1, !_vm.twoToggle) &&
              (_vm.twoToggle = !_vm.twoToggle)
          },
        },
      },
      [_vm._v(_vm._s(_vm.btnLabels[1]))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "circle-shortcut",
        class: {
          activated: _vm.threeToggle,
          deactivated: !_vm.threeToggle,
          disabled: _vm.checkLayerDisable(2),
        },
        on: {
          click: function ($event) {
            !_vm.checkLayerDisable(2) &&
              _vm.toggleBtn(2, !_vm.threeToggle) &&
              (_vm.threeToggle = !_vm.threeToggle)
          },
        },
      },
      [_vm._v(_vm._s(_vm.btnLabels[2]))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "circle-shortcut",
        class: {
          activated: _vm.fourToggle,
          deactivated: !_vm.fourToggle,
          disabled: _vm.checkLayerDisable(3),
        },
        on: {
          click: function ($event) {
            !_vm.checkLayerDisable(3) &&
              _vm.toggleBtn(3, !_vm.fourToggle) &&
              (_vm.fourToggle = !_vm.fourToggle)
          },
        },
      },
      [_vm._v(_vm._s(_vm.btnLabels[3]))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "circle-shortcut",
        class: {
          activated: _vm.fiveToggle,
          deactivated: !_vm.fiveToggle,
          disabled: _vm.checkLayerDisable(4),
        },
        on: {
          click: function ($event) {
            !_vm.checkLayerDisable(4) &&
              _vm.toggleBtn(4, !_vm.fiveToggle) &&
              (_vm.fiveToggle = !_vm.fiveToggle)
          },
        },
      },
      [_vm._v(_vm._s(_vm.btnLabels[4]))]
    ),
    _vm._v(" "),
    _vm.btnLabels.length > 5
      ? _c(
          "div",
          {
            staticClass: "circle-shortcut",
            class: {
              activated: _vm.sixToggle,
              deactivated: !_vm.sixToggle,
              disabled: _vm.checkLayerDisable(5),
            },
            on: {
              click: function ($event) {
                !_vm.checkLayerDisable(5) &&
                  _vm.toggleBtn(5, !_vm.sixToggle) &&
                  (_vm.sixToggle = !_vm.sixToggle)
              },
            },
          },
          [_vm._v(_vm._s(_vm.btnLabels[5]))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.btnLabels.length > 6
      ? _c(
          "div",
          {
            staticClass: "circle-shortcut",
            class: {
              activated: _vm.sevenToggle,
              deactivated: !_vm.sevenToggle,
              disabled: _vm.checkLayerDisable(6),
            },
            on: {
              click: function ($event) {
                !_vm.checkLayerDisable(6) &&
                  _vm.toggleBtn(6, !_vm.sevenToggle) &&
                  (_vm.sevenToggle = !_vm.sevenToggle)
              },
            },
          },
          [_vm._v(_vm._s(_vm.btnLabels[6]))]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }